<template>
    <div v-if="data != null">
        <a-modal v-model="visible" :title="data?.title"
            :width="formJson.config.width > 800 ? formJson.config.width : 800" centered destroyOnClose :footer="false">
            <k-form-build ref="kfb" :value="formJson" disabled />
        </a-modal>
    </div>
</template>

<script>
import utils from '@/common/utils';

export default {
    data() {
        return {
            visible: false,
            data: null,
            formData: null,
            formJson: null
        }
    },
    methods: {
        show(id) {
            utils.showSpin();
            this.http.get("/platform/collection/data/detail/" + id).then(ret => {
                // console.log(ret)
                this.data = ret.data;
                this.formData = JSON.parse(ret.data.formData);
                this.formJson = JSON.parse(ret.data.formJson);
                this.visible = true;
                this.$nextTick(() => {
                    this.$refs.kfb.setData(this.formData);
                });
            })
        }
    }
}
</script>

<style></style>